import { valueActionCreator } from '../action_creators';

export const SET_STUDENT_APPLICATIONS = 'SET_STUDENT_APPLICATIONS';
export const SET_APPLICATION_INTAKE = 'SET_APPLICATION_INTAKE';
export const REMOVE_APPLICATION = 'REMOVE_APPLICATION';
export const SET_STUDENT_APPLICATIONS_ERROR = 'SET_STUDENT_APPLICATIONS_ERROR';
export const SET_SELECTED_APPLICATIONS = 'SET_SELECTED_APPLICATIONS';

export const setStudentApplications = valueActionCreator(SET_STUDENT_APPLICATIONS);
export const setApplicationIntake = (appId, intake, intakeEsl) => ({
  type: SET_APPLICATION_INTAKE,
  appId,
  intake,
  intakeEsl,
});
export const removeApplication = appId => ({ type: REMOVE_APPLICATION, appId });
export const setStudentApplicationsError = (key, value) => ({
  type: SET_STUDENT_APPLICATIONS_ERROR,
  key,
  value,
});
export const setSelectedApplications = valueActionCreator(SET_SELECTED_APPLICATIONS);
